import { curry, curryRight, get } from 'lodash/fp';

export const getCurrentProgramStageId = state =>
    state.eventProgram.programStageStepper.stageId;

export const getActiveProgramStageStep = state =>
    state.eventProgram.programStageStepper.activeStep;

export const isProgramStageStepperActive = state =>
    !!state.eventProgram.programStageStepper.stageId;

export const getProgramStageById = curry((store, stageId) =>
    store.programStages.find(stage => stage.id == stageId)
);

export const getProgramStageIndexById = curry((store, stageId) =>
    store.programStages.findIndex(stage => stage.id == stageId)
);

export const getStageSectionsById = curry((state, id) => {
    const { programStageSections } = state;

    return get(id, programStageSections);
});



// WEBPACK FOOTER //
// ./src/EditModel/event-program/tracker-program/program-stages/selectors.js